import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteCarrierMemberActions as Actions,
  DeleteCarrierMemberRequestAction as RequestAction,
} from 'store/ducks/carrierMembers';

export function* deleteCarrierMemberRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `carrier-members/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Usuário removido com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
